<template>
  <div class="html-wrapper" v-html="htmlFile" />
</template>

<script>
export default {
  props: {
    htmlFile: {
      type: String,
      required: true
    }
  }
}
</script>

<style scoped>
.html-wrapper {
  padding: 1rem;
}
</style>